import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function StructuredData() {
  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Oluwatosin Adelaja',
    alternateName: 'Tosin Adelaja',
    url: 'https://tosinadelaja.com',
    image: 'https://tosinadelaja.com/logo512.png',
    sameAs: [
      'https://github.com/tintolee',
      'https://www.linkedin.com/in/adelaja-oluwatosin/',
      'https://twitter.com/mr_tinto',
      'https://www.researchgate.net/profile/Oluwatosin-Adelaja',
      'https://techcabal.com/author/oluwatosin-adelaja/',
      'https://hackernoon.com/u/tintolee',
      'https://www.npmjs.com/package/finprim',
      'https://outvalueapp.com'
    ],
    jobTitle: 'Senior Full Stack Engineer',
    description: 'Senior Full Stack Engineer with 8+ years building production fintech and healthtech platforms across the UK, Africa, and North America. Founder & CTO of OutValue. Crest Africa Tech Thought Leader of the Year 2025. First place, Hargreaves Lansdown Open Source Hackathon 2026.',
    knowsAbout: [
      'React',
      'React Native',
      'TypeScript',
      'JavaScript',
      'Node.js',
      'Next.js',
      'Firebase',
      'AWS',
      'GCP',
      'Azure',
      'GraphQL',
      'NestJS',
      'Stripe Payments',
      'KYC & Identity Verification',
      'Cross-border Payments',
      'Open Banking',
      'Software Architecture',
      'System Design',
      'Performance Optimization',
      'Accessibility',
      'Technical Writing',
      'Mobile Development',
      'Web Development',
      'Open Source',
      'Fintech',
      'Healthtech'
    ],
    worksFor: [
      {
        '@type': 'Organization',
        name: 'OutValue',
        url: 'https://outvalueapp.com',
        description: 'UK-registered home services marketplace'
      },
      {
        '@type': 'Organization',
        name: 'Lykris Innovation Global',
        description: 'UK-based digital agency'
      },
      {
        '@type': 'Organization',
        name: 'Changer',
        description: 'UK-based social impact startup'
      }
    ],
    alumniOf: [
      {
        '@type': 'CollegeOrUniversity',
        name: 'Obafemi Awolowo University',
        url: 'https://oauife.edu.ng'
      },
      {
        '@type': 'CollegeOrUniversity',
        name: 'IRGIB-Africa University'
      }
    ],
    hasCredential: [
      {
        '@type': 'EducationalOccupationalCredential',
        name: 'Tech Thought Leader of the Year',
        credentialCategory: 'Award',
        recognizedBy: {
          '@type': 'Organization',
          name: 'Crest Africa'
        },
        dateCreated: '2025'
      },
      {
        '@type': 'EducationalOccupationalCredential',
        name: 'First Place — Open Source Hackathon',
        credentialCategory: 'Award',
        recognizedBy: {
          '@type': 'Organization',
          name: 'Hargreaves Lansdown'
        },
        dateCreated: '2026-02'
      }
    ],
    email: 'adelajaolutosin@gmail.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Bristol',
      addressCountry: 'GB'
    }
  };

  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Oluwatosin Adelaja — Senior Full Stack Engineer',
    alternateName: 'Tosin Adelaja Portfolio',
    url: 'https://tosinadelaja.com',
    description: 'Portfolio of Oluwatosin Adelaja — Senior Full Stack Engineer, Founder & CTO of OutValue, Crest Africa Tech Thought Leader of the Year 2025, and open source author of finprim.',
    author: {
      '@type': 'Person',
      name: 'Oluwatosin Adelaja'
    },
    inLanguage: 'en-GB'
  };

  const profilePage = {
    '@context': 'https://schema.org',
    '@type': 'ProfilePage',
    mainEntity: {
      '@type': 'Person',
      name: 'Oluwatosin Adelaja',
      url: 'https://tosinadelaja.com',
      jobTitle: 'Senior Full Stack Engineer',
      hasOccupation: [
        {
          '@type': 'Occupation',
          name: 'Senior Full Stack Engineer',
          occupationalCategory: 'Software Development',
          skills: 'TypeScript, React, React Native, Node.js, Next.js, Firebase, AWS, GCP, Azure, GraphQL'
        },
        {
          '@type': 'Occupation',
          name: 'Founder and CTO',
          occupationalCategory: 'Technology Entrepreneurship',
          skills: 'Product Development, Mobile Architecture, Full Stack Engineering, Business Strategy'
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(person)}</script>
      <script type="application/ld+json">{JSON.stringify(website)}</script>
      <script type="application/ld+json">{JSON.stringify(profilePage)}</script>
    </Helmet>
  );
}
